import React, {Component, PropTypes} from 'react'

const IsOnline = (props) => props.visible
  ? <div className="pal-online">{props.sex == 1 ? 'Prisijungusi' : 'Prisijungęs'}</div>
  : <noscript />

const IsNew = (props) => props.visible
  ? <img src={`/dotnet/question/img/${props.gameType}/n.png`} className="pal-new" />
  : <noscript />

const LetsMeet = (props) => props.visible
  ? <div title="Susitinkam!" className="yes" onClick={props.onClick}>SUSITINKAM!</div>
  : <noscript />

const Reject = (props) => props.visible
  ? <img title="Ne" src={`/dotnet/question/img/${props.gameType}/x.png`} className="no" alt="" onClick={props.onClick} />
  : <noscript />

export default class Card extends Component {

  render() {
    const {valentine, uncover, voteBack, gameType} = this.props

      const hiddenCardClicked = valentine.loading === false ? (() => uncover(valentine.hiddenId, valentine.isOnline)) : null;

      const HiddenCard = () => <div className={'pal-card pal-card-front' + (valentine.loading ? ' pal-card-loading' : '')} onClick={hiddenCardClicked}>
        <img src={`/dotnet/question/img/${gameType}/card.png`} alt="" />
        <IsOnline visible={valentine.isOnline} sex={valentine.sex} />
        <IsNew visible={valentine.isNew} gameType={gameType} />
      </div>

    const VisibleCard = () => <div className="pal-card pal-card-back">
        <a href={`/narys.cfm?narys=${valentine.id}`} className="pal-userlink" title={`${valentine.name} (${valentine.age} m., ${valentine.city})`} target="_blank">
          <img src={valentine.photo} className="pal-userthumb" alt="" />
        </a>
        <IsNew visible={valentine.isNew} gameType={gameType} />
        <LetsMeet visible={typeof voteBack === 'function'} onClick={() => {voteBack(gameType, valentine, true)}} />
        <Reject visible={typeof voteBack === 'function'} gameType={gameType} onClick={() => voteBack(gameType, valentine, false)} />
      </div>

    return <div className={valentine.hidden ? 'pal-flip-container' : 'pal-flip-container pal-open'}>
      {valentine.hidden ? <HiddenCard /> : <VisibleCard />}
    </div>
  }
}
